
<template>
<Loader v-if="loader" />

    <div class="card p-3">
      <div class="grid">
          <div class="col-12 lg:col-5">
              <Dropdown v-model="selectedTypeFornitura" :options="typesFornitura" optionLabel="name" optionValue="name" placeholder="Seleziona tipo fornitura" class="inputfield w-full" />
             <div v-show="validationErrors.fornitura && submitted" class="p-error">Seleziona campo.</div>
          </div>
          <div class="col-12 lg:col-5">
              <Dropdown v-model="selectedTypePratica" :options="typesPratica" optionLabel="name" optionValue="name" placeholder="Seleziona tipo pratica" class="inputfield w-full" />
              <div v-show="validationErrors.pratica && submitted" class="p-error">Seleziona campo.</div>
          </div>
          <div class="col-2 lg:col-2">
            <Button label="Cerca" @click="searchData" icon="pi pi-search" iconPos="left" class="w-full" />
          </div>
      </div>
    </div>

    <div v-show="selectedItems.length > 0" class="btn-selected">
        <Button @click="setInSouspensionOrReactivation" class="p-button-warning p-3"  style="min-width:200px">
          Inoltra {{selectedItems.length}} elementi <i class="pi pi-send ml-5" style=""></i>
        </Button>
    </div>

    <div class="mt-3" v-if="items.length > 0">

      <div v-if="items.some(el => el.duplicate)">
        <Message severity="warn"> 
          Attenzione ci sono forniture duplicate
        </Message>
      </div>
      <div v-if="items.some(el => el.sameType)">
        <Message severity="warn"> 
          Attenzione ci sono forniture che hanno lo stato attuale uguale all'operazione da effettuare
        </Message>
      </div>
      <div v-if="items.some(el => el.out)">
        <Message severity="warn"> 
          Attenzione ci sono forniture uscite
        </Message>
      </div>
      <div v-if="items.some(el => !el.isDisalimentabile)">
        <Message severity="warn"> 
          Attenzione ci sono forniture non disalimentabili
        </Message>
      </div>
      <div v-if="items.some(el => el.udd && el.udd.includes('ANTARES')) && moment(new Date()).day() != 1">
        <Message severity="warn"> 
          Attenzione ci sono forniture con udd ANTARES che permette l'invio solo il lunedì
        </Message>
      </div>
      <div v-if="items.some(el => el.tutela)">
        <Message severity="warn"> 
          Attenzione ci sono forniture in tutela (in lavorazione o evasa)
        </Message>
      </div>
      <div v-if="items.some(el => el.contestazione == 1)" class="mb-2">
        <Message severity="info" :closable="false">
          <span class="legend-orange"></span>Fornitura con fattura contestata
        </Message>
      </div>

      <div>
        <DataTable ref="dt" class="p-datatable-sm" :value="items" v-model:selection="selectedItems" responsiveLayout="scroll" :filters="filters" :rowClass="getRowClass">
          <template #header>
              <div class="flex justify-content-between flex-wrap">
                  <div class="flex align-items-center justify-content-center mb-2">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                    </span>
                  </div>
                  <div class="flex align-items-center justify-content-center">
                    <Button v-if="selectedItems.length > 0" icon="pi pi-trash" :label="` Elimina (${selectedItems.length})`" @click="deletePreview(selectedItems)" class="p-button-danger mx-2" />
                    <Button icon="pi pi-external-link" label="Esporta" @click="exportCSV()" class="p-button-secondary mx-2" />
                  </div>
              </div>
          </template>
          <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
          <Column field="code" header="Fornitura" style="min-width:150px"></Column>
          <Column field="cc" header="Cc" style="min-width:130px;max-width:200px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.cc">{{ data.cc }}</div>
            </template>
          </Column>
          <Column field="udd" header="Udd" style="min-width:130px;max-width:200px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.udd">{{ data.udd }}</div>
            </template>
          </Column>
          <Column field="date" header="Data in preview" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.date)}}     
            </template>
          </Column>
          <Column field="data_inizio" header="Data Inizio" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.data_inizio)}}     
            </template>
          </Column>
          <Column field="data_fine" header="Data fine" style="min-width:120px">
            <template #body="{data}">
              {{formatDate(data.data_fine)}}     
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true" style="min-width:280px;max-width:380px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.note_cliente ? `${data.cliente} [${data.note_cliente}]` : data.cliente">
                {{ data.cliente }}<span v-if="data.note_cliente"> [<span class="p-error">{{ data.note_cliente }}</span>]</span>
              </div>
            </template>
          </Column>
          <Column field="rappresentante" header="Rappresentante" :sortable="true" style="min-width:180px;max-width:240px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.rappresentante">{{ data.rappresentante }}</div>
            </template>
          </Column>
          <Column field="agente" header="Agenzia" :sortable="true" style="min-width:160px;max-width:200px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.agente">{{ data.agente }}</div>
            </template>
          </Column>
          <Column field="agente_firmatario" header="Agente firmatario" :sortable="true" style="min-width:170px;max-width:200px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.agente_firmatario">{{ data.agente_firmatario }}</div>
            </template>
          </Column>
          <Column field="stato_fornitura" header="Stato Interno Attuale" :sortable="true" style="min-width:190px;max-width:220px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.stato_fornitura">{{ data.stato_fornitura }}</div>
            </template>
          </Column>
          <Column field="type" header="Tipo pratica" :sortable="true" style="min-width:130px" />
          <Column field="disalimentabile" header="Disalimentabile" style="min-width:130px">
            <template #body="{data}">
              <p v-if="data.disalimentabile == 'Y'"> Si</p>
              <p v-else-if="data.disalimentabile == 'N'"> No</p>   
            </template>
          </Column>
          <Column field="saldo" header="Saldo" :sortable="true" style="min-width:110px">
            <template #footer>
              <strong>Totale: {{ formatSaldo(totalSaldo) }}</strong>
            </template>
          </Column>
          <Column field="importo_contabile" header="Importo contabile" :sortable="true" style="min-width:150px">
            <template #body="{data}">
              <span
                :class="{ 'cursor-pointer text-blue-500': data.id_contabile }"
                @click="data.id_contabile ? goToContabili(data) : null"
              >
                {{ formatCurrencyValue(data.importo_contabile) }}
              </span>
            </template>
          </Column>
          <Column field="user" header="Gestito da" :sortable="true" style="min-width:150px;max-width:200px">
            <template #body="{data}">
              <div class="cell-clamp" :title="data.user">{{ data.user }}</div>
            </template>
          </Column>
          <Column bodyClass="col-avvisi" style="min-width:220px">
            <template #body="{data}">
              <ul>
                <li class="p-error text-xs" v-if="data.duplicate"> Duplicato</li>
                <li class="p-error text-xs" v-if="data.sameType"> Stato attuale uguale all'operazione</li>
                <li class="p-error text-xs" v-if="data.out"> Fornitura uscita</li>
                <li class="p-error text-xs" v-if="!data.isDisalimentabile"> Fornitura non disalimentabile</li>
                <li class="p-error text-xs" v-if="data.tutela"> Fornitura in tutela ({{ data.stato_tutela_label }})</li>
              </ul>
            </template>
          </Column>  
          <Column>
            <template #body="{data}">
                <i @click="deletePreview(data)" class="pi pi-trash"></i>
              </template>
          </Column>
        </DataTable>
      </div>
    </div>
</template>

<script>

import Service from '@/services/ask-pratiche/pratiche-service'
import ServiceOperation from '@/services/ask-operation/operation-service'
// import RecuperoCreditoService from '@/services/ask-management/recupero-credito-service'
import { computed, getCurrentInstance, ref } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import moment from 'moment';
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router';

export default {
    components: {
      Loader
    },
    setup() {
        
      const dt = ref();
      const toast = useToast();
      const loader = ref(false);
      const self = getCurrentInstance();
      const router = useRouter();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const serviceOperation = new ServiceOperation(self.$http, self.$eventBus)
      // const recuperoCreditoService = new RecuperoCreditoService(self.$http, self.$eventBus)
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const validationErrors = ref({})
      const submitted = ref(false)
      const items = ref([])
      const selectedItems = ref([])
      const selectedTypeFornitura = ref()
      const typesFornitura = ref([
        {name: 'TUTTI'},
        {name: 'POD'},
        {name: 'PDR'},
      ])
      // stati_tutela.id che devono generare un avviso in preview
      const statiTutelaBloccanti = {
        3: 'Tutela in lavorazione',
        4: 'Tutela evasa',
      }
      const selectedTypePratica = ref()
      const typesPratica = ref([
        {name: 'TUTTI'},
        {name: 'sospensioni'},
        {name: 'riattivazioni'},
      ])


      const searchData = () => {
        submitted.value = true
        if (validateForm()) {
          loader.value = true
          service.getPreviewSospensioniRiattivazioni(selectedTypeFornitura.value, selectedTypePratica.value)
          .then((res) => {
            items.value = res.items
            checkErrors()
          }).finally(()=>{
            loader.value = false
          })
        }
      }

      const setInSouspensionOrReactivation = async () => {
        loader.value = true
        try {
          const selected = Array.isArray(selectedItems.value) ? selectedItems.value : []

          // const normalizeClientName = (v) => {
          //   if (v == null) return null
          //   if (typeof v !== 'string') return v
          //   return v.toLowerCase().replace(/\s+/g, ' ').trim()
          // }

          const checkResults = await Promise.all(
            selected.map(async (item) => {
              const cod_pod =
                item?.cod_pod ??
                item?.codPod ??
                item?.pod_id ??
                (selectedTypeFornitura.value === 'POD' ? item?.id : null)

              const cod_pdr =
                item?.cod_pdr ??
                item?.codPdr ??
                item?.pdr_id ??
                (selectedTypeFornitura.value === 'PDR' ? item?.id : null)

              if (!cod_pod && !cod_pdr) return { item, blocked: false }

              // const res = await recuperoCreditoService.getInfoClienteVoltura({
              //   cod_pod,
              //   cod_pdr,
              // })

              // const expectedClienteId =
              //   item?.cliente?.id ??
              //   item?.cliente_id ??
              //   item?.clienteId ??
              //   item?.cod_cliente ??
              //   item?.id_cliente ??
              //   null
              // const expectedRagsoc =
              //   item?.cliente?.ragsoc ??
              //   item?.ragsoc ??
              //   (typeof item?.cliente === 'string' ? item?.cliente : null)

              // const returnedCliente = res?.cliente
              // const returnedClienteId = returnedCliente?.id ?? null
              // const returnedRagsoc = returnedCliente?.ragsoc ?? null
              // const returnedFullName = [returnedCliente?.nome, returnedCliente?.cognome]
              //   .filter(Boolean)
              //   .join(' ')
              //   .trim()
              // const returnedDisplayName = returnedRagsoc || returnedFullName || null

              let blocked = false
              // if (res?.success && res?.has_voltura) {
              //   if (expectedClienteId != null && returnedClienteId != null) {
              //     blocked = returnedClienteId !== expectedClienteId
              //   } else if (expectedRagsoc && returnedDisplayName) {
              //     blocked =
              //       normalizeClientName(returnedDisplayName) !==
              //       normalizeClientName(expectedRagsoc)
              //   } else {
              //     blocked = true
              //   }
              // }
              return { item, blocked }
            })
          )

          const blockedItems = checkResults.filter((r) => r.blocked).map((r) => r.item)
          const allowedItems = checkResults.filter((r) => !r.blocked).map((r) => r.item)

          if (blockedItems.length > 0) {
            const blockedCodes = blockedItems
              .map((i) => i.code ?? i.id)
              .filter(Boolean)
              .join(', ')
            toast.add({
              severity: 'warn',
              summary: 'Attenzione',
              detail: `Impossibile inoltrare per voltura: ${blockedCodes}`,
            })
          }

          if (allowedItems.length === 0) return

          const res = await serviceOperation.setInSouspensionOrReactivation(allowedItems)

          if (Object.keys(res.items.fornitori_not_configured).length > 0) {
            toast.add({
              severity: 'warn',
              summary: 'Attenzione',
              detail: `Alcuni fornitori non configurati per ${
                Object.values(res.items.fornitori_not_configured)
                  .flatMap((supplierDataArray) =>
                    supplierDataArray.map((supplierData) => supplierData.code)
                  )
                  .join(', ')
              }`,
            })
          }

          toast.add({ severity: 'success', summary: 'Successo', detail: res.items.msg })
          searchData()
          selectedItems.value = []
        } finally {
          loader.value = false
        }
      }

      const deletePreview = (data) => {
        loader.value = true
        let objs = []
        if (Array.isArray(data)) {
            objs = data
        } else {
            objs = [data]
        }
        serviceOperation.deletePreviewSouspensionOrReactivation(objs)
        .then(() => {
          searchData()
          selectedItems.value = []
        }).finally(()=>{
          loader.value = false
        })
      }

      const checkErrors = () => {
        let today = moment()
        let codes = items.value.map(item => item.code);
        let d = codes.filter((item, index) => codes.indexOf(item) !== index);
        let duplicates = [...new Set(d)];

        items.value.map(el => {
          el.duplicate = false
          el.sameType = false
          el.out = false
          el.isDisalimentabile = false
          el.tutela = false
          el.stato_tutela_label = null
          if (duplicates.includes(el.code)) {
            el.duplicate = true
          }
          if (((el.stato_fornitura == 'Riattivazione richiesta' || el.stato_fornitura == 'Riattivazione in lavorazione' || el.stato_fornitura == 'In riattivazione' || el.stato_fornitura == 'Riattivato') && el.type == 'riattivazioni') || 
            ((el.stato_fornitura == 'Sospensione richiesta' || el.stato_fornitura == 'Sospensione in lavorazione' || el.stato_fornitura == 'In sospensione' || el.stato_fornitura == 'Sospeso') && el.type == 'sospensioni')) {
            el.sameType = true
          }

          if (moment(el.data_fine).isBefore(today, 'day') || !el.data_fine) {
             el.out = true
          }
          if (el.disalimentabile != 'N') {
             el.isDisalimentabile = true
          }
          const statoTutela = statiTutelaBloccanti[Number(el.stato_tutela)]
          if (statoTutela) {
            el.tutela = true;
            el.stato_tutela_label = statoTutela;
          }
        });
      };

      const normalizeSaldo = (value) => {
        if (value == null || value === '') {
          return 0;
        }

        if (typeof value === 'number') {
          return Number.isFinite(value) ? value : 0;
        }

        const raw = String(value).trim().replace(/\s/g, '');
        const hasComma = raw.includes(',');
        const hasDot = raw.includes('.');

        let normalized = raw;

        if (hasComma && hasDot) {
          normalized = raw.replace(/\./g, '').replace(',', '.');
        } else if (hasComma) {
    
          normalized = raw.replace(',', '.');
        } else {
         
          normalized = raw;
        }

        normalized = normalized.replace(/[^\d.-]/g, '');

        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const totalSaldo = computed(() => {
        return items.value.reduce((total, item) => total + normalizeSaldo(item.saldo), 0);
      });

      const formatSaldo = (value) => {
        return new Intl.NumberFormat('it-IT', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      };

      const formatCurrencyValue = (value) => {
        return formatSaldo(normalizeSaldo(value));
      };

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      const goToContabili = (data) => {
        if (!data?.id_contabile) return;
        const routeData = router.resolve({
          name: 'Contabili',
          query: {
            id_contabile: data.id_contabile
          }
        });
        window.open(routeData.href, '_blank');
      };

      const getRowClass = (data) => {
        return data.contestazione == 1 ? 'row-contestazione' : '';
      };

      
      const validateForm = () =>{
        if (selectedTypeFornitura.value == null)
          validationErrors.value['fornitura'] = true;
        else 
          delete validationErrors.value['fornitura'];

        if (selectedTypePratica.value == null)
          validationErrors.value['pratica'] = true;
        else 
          delete validationErrors.value['pratica'];
    
        return !Object.keys(validationErrors.value).length;
      }
      

      return {
        moment,
        dt,
        loader,
        filters,
        validationErrors,
        submitted,
        typesFornitura,
        selectedTypeFornitura,
        typesPratica,
        selectedTypePratica,
        searchData,
        items,
        selectedItems,
        setInSouspensionOrReactivation,
        deletePreview,
        formatDate,
        exportCSV,
        getRowClass,
        totalSaldo,
        formatSaldo,
        formatCurrencyValue,
        goToContabili
      }
    }
}
</script>

<style scoped>
.btn-selected {
  position:fixed;
  bottom:60px; 
  right:40px;
  z-index:2;
}
.pi-trash {
  color: rgb(254, 88, 88);
  cursor: pointer;
}
:deep(.p-datatable .p-datatable-tbody > tr.row-contestazione > td) {
  background-color: #ff99009b !important;
}
/* La tabella scorre in orizzontale invece di comprimere le colonne:
   le stringhe lunghe non mandano piu' a capo il testo alzando il rigo. */
:deep(.p-datatable-wrapper) {
  overflow-x: auto;
}
:deep(.p-datatable .p-datatable-thead > tr > th),
:deep(.p-datatable .p-datatable-tbody > tr > td) {
  white-space: nowrap;
  vertical-align: middle;
}
/* I <p> dentro le celle portano i margini di default del browser. */
:deep(.p-datatable .p-datatable-tbody > tr > td p) {
  margin: 0;
}
/* Unica colonna che resta su piu' righe: l'elenco degli avvisi. */
:deep(.p-datatable .p-datatable-tbody > tr > td.col-avvisi) {
  white-space: normal;
}
:deep(td.col-avvisi ul) {
  margin: 0;
  padding-left: 1rem;
}
/* Le colonne di testo lungo vanno a capo una sola volta, poi ellissi.
   Il max-width sulla colonna limita la larghezza, il clamp l'altezza:
   il rigo non cresce ne' in un verso ne' nell'altro. Testo intero nel tooltip.
   Serve il div interno: max-height e overflow sul <td> il browser li ignora. */
.cell-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;
  line-height: 1.35;
}
.legend-orange {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #ff99009b;
  border-radius: 2px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
